import type { ReportConfig, Report } from '@/types';
import { api } from './api-client';

type SaveReportProps = {
  projectId: string;
  name: string;
  description?: string;
  config: ReportConfig;
};

export const ReportsService = {
  getReports: async ({
    projectId,
    signal,
  }: {
    projectId: string;
    signal?: AbortSignal;
  }) => {
    const { data } = await api.get<{ data: Report[] }>(
      `/reports?projectId=${projectId}`,
      { signal },
    );
    return data;
  },

  saveReport: async ({
    projectId,
    name,
    description,
    config,
  }: SaveReportProps) => {
    await api.post(`/reports`, { projectId, name, description, config });
  },

  deleteReport: async ({ reportId }: { reportId: string }) => {
    await api.delete(`/reports/${reportId}`);
  },
};
